/**
 * 信令服务配置：单一配置来源为 apps/console/.env.local 或部署环境中的 SIGNAL_SERVER_URL。
 *
 * 解析优先级（从高到低）：
 *   1. sessionStorage 临时覆盖（is_debug + dev_server），用于运行时切换信令地址，无需重启 dev server
 *   2. dev 构建：fetch 走 "/apis" 前缀、socket.io 走 path "/apis/socket.io"，
 *      由 Vite dev server 反代到 env 指定的真实信令服务（绕 CORS）
 *   3. prod 构建：直连 env 注入的绝对 URL（__SIGNAL_SERVER_URL__）
 *
 * 暴露：
 *   - SIGNAL_SERVER_URL：fetch 用的基础地址，例如 `${SIGNAL_SERVER_URL}/api/xxx`
 *   - SIGNAL_SOCKET_URL：socket.io 连接的 URL（dev 下为当前 origin，其余为绝对地址）
 *   - SIGNAL_SOCKET_PATH：socket.io 的 path 选项（dev 下为 "/apis/socket.io"，其余默认 "/socket.io"）
 */

const IS_DEV = import.meta.env.DEV;

const debugOverride =
	sessionStorage.getItem("is_debug") === "true"
		? sessionStorage.getItem("dev_server") || null
		: null;

export const SIGNAL_SERVER_URL =
	debugOverride ?? (IS_DEV ? "/apis" : __SIGNAL_SERVER_URL__);

export const SIGNAL_SOCKET_URL =
	debugOverride ?? (IS_DEV ? window.location.origin : __SIGNAL_SERVER_URL__);

export const SIGNAL_SOCKET_PATH =
	!debugOverride && IS_DEV ? "/apis/socket.io" : "/socket.io";
